module.exports = __webpack_public_path__ + "assets/img/hzhb3.20341d7d.png";